<template>
    <div class='login-box' :style="bgStyle">
        <img class="logo" :src="allData.companyLogoBase64 ? 'data:image/png;base64,'+ allData.companyLogoBase64 : require('@/assets/img/logo.png')" alt="">
        <div class="box">
            <v-container class="pa-0" fluid fill-height>
                <v-row no-gutters class="h-full">
                    <div
                        class=" d-flex flex-column align-center   login-box-style"

                        :style="boxAbsolute"

                    >
                        <div class="binding">
                          <div class="binding-title">{{$t('login.subAccount.title')}}</div>
                          <div class="binding-subtitle">{{$t('login.subAccount.subtitle')}}</div>
                          <div class="subaccount-list-scorll">
                            <v-list flat>
                              <v-list-item-group
                                v-model="subRuleForm.subusername"
                                color="primary"
                              >
                                <v-list-item
                                  v-for="(item, i) in nameList"
                                  :key="i"
                                  :value="item.subusername"

                                >
                                  <v-list-item-avatar >

                                    <v-icon color="#5066e0">
                                      {{ icons.mdiAccountCircle }}
                                    </v-icon>

                                  </v-list-item-avatar>

                                  <v-list-item-content>
                                    <v-list-item-title :title="item.subusername + (item.isEntrustAccount == 1?' (被委托账号)':'')">{{item.subusername}} <span class="entrust-account-span" v-if="item.isEntrustAccount == 1"> (被委托账号)</span></v-list-item-title>
                                  </v-list-item-content>

                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </div>


<!--                          <v-form-->
<!--                              @submit.native.prevent-->
<!--                                class="form-box mb-6"-->
<!--                                ref="subRuleForm">-->
<!--                                <v-select-->
<!--                                    :items="nameList"-->
<!--                                    v-model="subRuleForm.subusername"-->
<!--                                    item-text="subusername"-->
<!--                                    item-value="subusername"-->
<!--                                    :menu-props="{ top: true, offsetY: true }"-->
<!--                                    outlined-->
<!--                                    dense-->
<!--                                    :placeholder="$t('login.subAccount.placeholder')"-->
<!--                                    hide-details="auto"-->
<!--                                ></v-select>-->

                                <v-btn color="primary" min-height="50" :disabled="!subRuleForm.subusername" class="btn-box w-full" @click="subOk" style="margin-top:35px;">{{$t('btn.submit')}}</v-btn>
<!--                            </v-form>-->
                        </div>
                    </div>

                </v-row>
            </v-container>
        </div>

    </div>
</template>

<script>

import { getLoginApp} from "@/api/index";
import {snackbarMsg} from '@/utils/index'
import VCarousels from './carousel'
import {
  mdiAccountCircle,

} from '@mdi/js'
import { IsPC } from '../../utils'
export default {
    components:{
        VCarousels
    },
    data() {
        return {
			subRuleForm: {},
            subRules: {
                subusername: [
                    { required: true, message: this.$t('login.subAccount.placeholder') }
                ],
            },
            layout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 14 },
            },
            rowData: {},
            nameList: [],
            allData: {
                authSourceList: []
            },
          //企业自定义登录界面样式
          diy:{
            bg:require('@/assets/img/bg1.png'),
            opacity:0,
            type:1,
            bgColor:'#fffff',
            top:20,
            left:88,
          },
          icons: {
            mdiAccountCircle,
          },
        };
    },
    created() {
        this.getData()
       this.nameList= JSON.parse(this.decode(this.$route.query.rowData))

        // for(let item of subAccountList) {
        //   if(item.isEntrustAccount == 1 ) {
        //     item.subusername = item.subusername +'(被委托账号)'
        //   }
        // }
        // this.nameList = subAccountList
    },
  computed:{

    bgStyle() {
      if(this.diy.type == 1){
        let opacity = this.diy.opacity>0?(this.diy.opacity/100):0
        return   {
          'background-image': 'linear-gradient(rgba(0, 0, 0, '+opacity+'), rgba(0, 0, 0, '+opacity+')),  url("'+this.diy.bg+'")',
          'background-repeat': 'no-repeat',
          'background-origin':' border-box',
          'background-position': 'left center',
          'background-size':'cover',
        }
      }

      return {
        'background-color':this.diy.bgColor,
      }
    },



    boxAbsolute(){

      let style = {
        "position": "absolute"
      }
      if(!this.diy.left && this.diy.left != 0) {
        this.diy.left = 88
      }
      let left = this.diy.left > 0?(100 - parseInt(this.diy.left))/100:1
      let b = `calc((100vw - 460px) * ${left}`
      style = {
        "position": "absolute",
        "top":this.diy.top + '%',
        "right":b
      }
      console.log(IsPC())
      if(!IsPC()){

        style = {
          "position": "none",
          "margin-top": '30%',
          "margin-left":'auto',
          "margin-right":'auto',
        }
      }

      return style

    }

  },
    methods: {
      //设置网站登录页面样式
      setLoginStyle(data){
        if(data){
          let style = Object.assign({},this.diy)
          style.top = data.top
          style.left = data.left
          style.type = data.type
          if(data.type == 1){
            style.opacity = data.opacity?data.opacity:1
            if(data.coverImgBase64) {
              style.bg = "data:image/jpeg;base64,"+data.coverImgBase64
            }else{
              style.bg  = require('@/assets/img/bg'+data.defaultCoverImg+'.png')
            }

          }else{
            style.bgColor = data.color
          }
          this.diy = style
        }
      },
        decode(base64){
            // 对base64转编码
            var decode = atob(base64);
            // 编码转字符串
            var str = decodeURI(decode);
            return str;
        },
        getData() {
            let params = {
                appDomainName: window.location.href
            }
            getLoginApp(params).then(res=> {
                if (res.code == this.$GLOBA.StatusOK) {
                    this.allData = res.data
                    if(res.data.loginStyle){
                      this.setLoginStyle(res.data.loginStyle)
                    }
                }
            })
        },
      subOk() {

              if (this.subRuleForm.subusername) {
                if(this.allData.appType == 36 || this.allData.protocolType == 32) {

                  this.$router.push({
                        path: "/downSapPage",
                        query: {
                            appKey: this.allData.appKey,
                            appType: this.allData.appType,
                            protocolType:this.allData.protocolType,
                            subUsername: this.subRuleForm.subusername
                        },
                    })
                }else{
                    let nowName = this.nameList.filter(val => val.subusername ==  this.subRuleForm.subusername)[0]

                  if (nowName.enable == 1) {
                      snackbarMsg('error',this.$t('login.subAccount.unuse'))
                  } else {
                     this.$serverUrlFun().then(serverUrl=> {
                    var url = serverUrl+'/application/signOn/'+this.allData.appKey+'/'+this.subRuleForm.subusername;
                    window.open(url, "_self");
                  })
                }
                  }


              } else {
                  return false;
              }
      },
    },
}
</script>

<style lang='scss' scoped>

.login-box {
    height: 100%;
    display: flex;
    position: relative;
    .logo {
        position: absolute;
        top: 30px;
        left: 40px;
        height: 60px;
    }
    .box {
        /*background: #FFFFFF;*/
        /*box-shadow: 0px 15px 50px 0px rgba(103, 182, 206, 0.27);*/
        flex: 1;
        display: flex;
        .login-icon {
            width: 100%;
        }

        .img-box {
            position: relative;
            width: 100%;
            height: 100%;
        }
        .login-title-icon {
            position: absolute;
            z-index: 1;
            height: 100%;
            right: 0;
            width: 100%;
            top: 0;
        }

    }

    .binding {
        // min-width: 380px;
        // padding-top: 15%;
        // margin-left: 250px;
        min-width: 400px;
        max-width: 460px;
        background-color: #FFFFFF;
        border-radius: 10px;
        padding: 20px;
        z-index: 15;
        @media screen and (min-width: 320px) and (max-width: 480px){
            padding: 10px;
        }
        .form-box ::v-deep {
            padding: 50px 0;
            .ant-form-item {
                margin-bottom: 30px;
            }
            .ant-select-selection {
                font-size: 16px;
                height: 50px;
                border-radius: 10px;
                padding-left: 30px;
            }
            .ant-select-selection--single .ant-select-selection__rendered {
                height: 50px;
                line-height: 50px;
            }
            .btn-box {
                width: 100%;
                height: 50px;
                line-height: 50px;
                background: #5066e0;
                box-shadow: 0px 0px 10px 1px rgba(0, 80, 179, 0.2);
                border-radius: 10px;
                font-size: 18px;
                font-weight: 500;
                color: #FFFEFE;
                margin-top: 30px;
            }
        }
        .ant-input-password ::v-deep {
            .ant-input-suffix {
                right: 20px;
            }
        }
    }
}
.binding-title {
    height: 70px;
    line-height: 70px;
    font-size: 28px;
    font-weight: 400;
    opacity: 0.9;
    text-align:left;
}
  .binding-subtitle {
    font-size: 20px;
    opacity: 0.9;
    font-weight: 100;
    color: #686464;
  }
  .entrust-account-span {
    color: #9a999dde;
    margin-left: 15px;
  }
  .v-list-item {
    .v-list-item__title {
      line-height: 1.5;
      max-width:300px ;
    }
  }
  .subaccount-list-scorll {
    max-height: 400px;
    overflow-y: scroll;
  }
  @media screen and (min-width: 320px) and (max-width: 480px){
    .binding-title {
        line-height: 34px;
    }
  }
</style>
